window.addEventListener('DOMContentLoaded', (event) => {
  const accordionHeaderEls = document.querySelectorAll('.faq-title');

  accordionHeaderEls.forEach(header => {
    header.addEventListener('click', (e) => {

        const content = header.nextElementSibling;
        content.toggleAttribute('hidden');

        const buttonEl = header.querySelector('.faq-button');
        const isExpanded = buttonEl.getAttribute('aria-expanded') === 'true';
        buttonEl.setAttribute('aria-expanded', !isExpanded);
    });
  });

});

